<app-upload-input #uploadFileRef (fileUpload)="onFileUpload($event)" [accepted]="acceptedExtension"></app-upload-input>